export default __webpack_public_path__ + "static/media/hero-banner-overlay.77f81762.svg";